<template>
<div class="jss117 pt-5">
  <section class="sc-o27kl3-0 gsZmuC product-slider-section mt-5 mb-4  rounded pr-2"  v-for="pitem,index in props.products" :key="index" :data-group-id="pitem.gid" v-show="pitem.items.length">
  <div class="py-3 d-flex justify-content-between align-items-center">
  <div>
    <h3 class="text-light" style="font-size:1.2em;font-weight:600">{{ pitem.name }}</h3>
    <small class="text-light">{{ pitem.description }}</small>
  </div>
  <div class="pl-2 h3" style="color:#443591" v-if="pitem.type == 'discounted' && pitem.timer == 1">
  {{ pitem.numerator }}
  </div>
  </div>
    <div>
      <div class="sc-d8w7bo-1 jpdybm">
        <div direction="row" class="sc-1r3hge1-0 heMFVq scroll-example">
        <product-template :list="pitem.items" />
          <!-- <div v-for="item,index in pitem.items" :key="item.id" class="position-relative">
            <div class="bg-white px-2 pt-1 rounded" style="height:225px">
              <button-template v-if="!item.store_active" :id="item.id" :sid="item.place_id" :quantity="item.quantity" origin="product" />
              <span v-else class="product-new-top bg-red w-100 rounded d-flex bg-secondary" style="height: 30px;justify-content: center;align-items: center;">فروشگاه بسته است</span>
              <div @click="goProductPage(item.id,item.store_active)"> 
                <figure class="sc-1q5lmzx-2 ktLvGN thumbnail-Wrapper">
                  <img :src="'https://radap.ir/'+item.img_url" class="product-img" :alt="item.name" > 
                  <span class="product-name">{{item.name }}</span> 
                  <span class="product-description text-muted">{{item.description }}</span> 
                </figure>
              </div>
              <footer class="mb-1">
                  <div :class="{'visible' : item.discount > 0 , 'invisible' : item.discount == 0 }">
                    <div>
                      <del class="small pe-1 text-muted">{{convertToPersian(numberFormat(item.price))}}</del> 
                      <label class="text-danger p--5 product-discount" :class="{'peculiar-discount' : item.discount > 4}">%{{convertToPersian(item.discount)}}</label> 
                    </div> 
                  </div>
                    <div>
                      <strong>{{convertToPersian(numberFormat((parseInt(removeCommos(item.price)) - (parseInt(removeCommos(item.price)) * (parseInt(item.discount) / 100)))))}}</strong>
                      <small>تومان</small>
                    </div>
              </footer>
            </div>
          </div> -->
        </div>
        <div class="text-center">
        <button class="btn w-98" style="background-color: #eef1f9;"  @click="goWoleMainGroups(pitem.id)">نمایش همه</button>
        </div>
      </div>
    </div>
</section>
</div>
</template>

<script setup>
import { defineProps } from 'vue';
import ProductTemplate from '../../item/product.vue';
import ButtonTemplate from '../../item/button.vue';
import { numberFormat,convertToPersian,removeCommos } from '@/composables/digits';
let props = defineProps(['products']);
import {useRoute,useRouter} from 'vue-router';
let route = useRoute()
let router = useRouter()
function goWoleMainGroups(id){
  router.push({name:'WoleBtn',params:{item:id,storeId:route.params.id,whole:'groups'}})
}
</script>

<style scoped>
@import '../../../../assets/css/product.css';
section {
background: #F87C56;
    box-shadow: 4px 4px 8px 2px rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
  .w-98{
    width: 98%;
  }
  
.ktLvGN > div {
    max-width: 111px !important;
    margin-bottom: 0 !important;
}
.product-name{
    max-height: 22px;
    font-size: 14px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: black;
    margin-top: .25em;
    font-family: "IranSans";
}
.product-description{
    height: 22px;
    font-size: 11px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: black;
    font-family: "IranSans";
}
.product-img{
    max-height: 120px !important;
    min-height: 120px !important;
    max-width: 120px !important;
    min-width: 120px !important;
    margin-right: auto;
    margin-left: auto;
}
.product-discount{
  border: 1px solid red;
  line-height: 1.1;
  font-size: 12px;
  font-weight: 700;
  border-radius: 4px;
}
.p--5{
  padding: .25em .125em;
}
.heMFVq > * {
    width: 155px;
}
</style>